export const ModalScrollView = () => null;
export const useIsInModalNavigation = () => false;
export const ModalPanDownGestureProvider = (props: any) => props.children;
